import { getBackEndVars } from './paypal/getVariables';
import { getValidPromoCode } from './promo-validity-handler';

export const getDiscountFlow = () => {
  if (!getBackEndVars().discountData?.pageIsDiscount) {
    return null;
  }

  let discountFlow = 'direct';

  if (hasAppliedDiscount()) {
    discountFlow = 'payment_method_closure';
  } else if (getValidPromoCode()) {
    discountFlow = 'promo_code_application';
  }
  return discountFlow;
};

const hasAppliedDiscount = () => localStorage.getItem('discountApplied');
